<form-field [formGroup]="fieldConfig?.formGroup"
            [options]="fieldConfig"
            [isInternalError]="isInternalError"
            [attr.class]="fieldConfig?.className"
            [ngClass]="{'no-icon': !fieldConfig?.iconDefinition && !fieldConfig?.icon}">
    <autocomplete-input #input
                        [formControlName]="fieldConfig?.formControlName"
                        [formControl]="fieldConfig?.formGroup.get(fieldConfig?.formControlName)"
                        [placeholder]="fieldConfig?.placeholder"
                        [icon]="fieldConfig?.icon"
                        [iconDefinition]="fieldConfig?.iconDefinition"
                        [displayFn]="displayFn"
                        [isExactMatchFn]="isExactMatchFn"
                        [createFn]="createFn"
                        [options]="options"
                        [autoActiveFirstOption]="autoActiveFirstOption"
                        [isLoading]="isLoading"
                        [forceFocus]="forceFocus"
                        [delayBlur]="delayBlur"
                        [allowSelectOnBlur]="allowSelectOnBlur"
                        [forceBlur]="forceBlur"
                        [autocompleteDisabled]="autocompleteDisabled"
                        [autocompleteTransparent]="autocompleteTransparent"
                        [removeEmptyOptions]="removeEmptyOptions"
                        (onChangeInput)="changeInputEvent($event)"
                        (onBlur)="blurEvent($event)"
                        (onFocus)="focusEvent($event)"
                        (onValueSelected)="valueSelectedEvent($event)"
                        (onOpenPanel)="openPanelEvent()"
                        (onClosePanel)="closePanelEvent()"
                        (onKeyUp)="keyUpEvent($event)">
        <ng-template let-option>
            <ng-container [ngTemplateOutlet]='template' [ngTemplateOutletContext]='{ $implicit: option }'></ng-container>
        </ng-template>
        <ng-container class="end-list-positionned">
            <ng-content selector=".end-list-positionned"></ng-content>
        </ng-container>
    </autocomplete-input>
</form-field>
